import { Box, Typography } from "@mui/material"

type UnavailableOverlayProps = {
  statusText?: string
  borderRadius: string | number
}

const UnavailableOverlay = ({
  statusText,
  borderRadius,
}: UnavailableOverlayProps) => {
  return (
    <>
      <Box
        data-testid="unavailable-overlay"
        sx={{
          position: "absolute",
          inset: 0,
          zIndex: 11,
          overflow: "hidden",
          borderRadius,
          p: 1,
          pb: 0,
        }}
      >
        <svg
          data-testid="diagonal-lines-svg"
          width="100%"
          height="100%"
          viewBox="0 0 100 100"
          preserveAspectRatio="none"
        >
          <g stroke="#666" strokeWidth="0.5">
            <line x1="0" y1="0" x2="100" y2="100" />
            <line x1="100" y1="0" x2="0" y2="100" />
          </g>
        </svg>
      </Box>

      <Typography
        variant="body2"
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 12,
          bgcolor: "white",
          px: 1,
          py: 0.5,
          color: "primary",
          fontWeight: "bold",
          textAlign: "center",
          whiteSpace: "nowrap",
        }}
      >
        {statusText}
      </Typography>
    </>
  )
}

export default UnavailableOverlay
